import store from '@/store'

export default async (to, from, next) => {
  if (store.getters['CustomerType/isCustomerTypesEmpty']) {
    store.dispatch('wait/start', 'app loading', { root: true })
    await store.dispatch('CustomerType/fetchCustomerTypes')
    store.dispatch('wait/end', 'app loading', { root: true })
  }

  next()
}
